import * as Constants from "./../../../constants";
import { t } from '../../../content';

import greenLogoNoText from "../../../assets/images/logos/apex_analytics_green_logo.svg";
import groupOfPeople from '../../../assets/images/icons/groupOfPeople.svg';
import suitcase from '../../../assets/images/icons/suitcase.svg';
import search from '../../../assets/images/icons/search.svg';
import question from '../../../assets/images/icons/question.svg';
import calculator from '../../../assets/images/icons/calculator.svg';
import cog from '../../../assets/images/icons/cog.svg';
import companyIcon from '../../../assets/images/icons/companyIcon.svg';
import JoinInnerOutlinedIcon from '@mui/icons-material/JoinInnerOutlined';
import ThreePIcon from '@mui/icons-material/ThreeP';

const processedMenu = (fullMenu, userRole) => {
    const hiddenSubmenus = [];
    const hiddenMenuItems = [];
    let MenuTitleChange = {};
    let processedMenu = [];

    if (userRole === Constants.USER_ROLE_SPECIALIST) {
        // Hide by stable ids — never by English titles
        hiddenSubmenus.push('teams', 'openPositions', 'talentAnalytics');
        hiddenMenuItems.push('talents', 'recruitment');
        MenuTitleChange = {
            teamManagement: t('nav.groups.analyticsAlias')
        }

        processedMenu = fullMenu.filter((menuItem) => {
            if (hiddenMenuItems.includes(menuItem.id)) {
                return false;
            }
            return true;
        }).map((menuItem) => {
            const next = {
                ...menuItem,
                submenu: menuItem.submenu ? [...menuItem.submenu] : menuItem.submenu,
            };

            if (Object.keys(MenuTitleChange).includes(next.id)) {
                next.title = MenuTitleChange[next.id];
            }

            if (next.submenu) {
                next.submenu = next.submenu.filter((submenuItem) => {
                    return !hiddenSubmenus.includes(submenuItem.id);
                });
            }

            return next;
        });
    } else if ([Constants.USER_ROLE_OWNER].includes(userRole)) {
        processedMenu = fullMenu.filter(item => item.id === 'dashboard');
    } else {
        processedMenu = fullMenu;
    }

    return processedMenu;
}


const buildPrimaryMenuItems = () => [
    {
        enabled: true,
        id: 'teamManagement',
        title: t('nav.groups.teamManagement'),
        icon: <img className='navIcon' src={groupOfPeople} alt="team audit" />,
        submenu: [
            {
                id: 'teams',
                title: t('nav.items.teams'),
                path: '/team-review',
            },
            {
                id: 'teamAnalytics',
                title: t('nav.items.teamAnalytics'),
                path: '/team-analytics',
            },
        ]
    },
    {
        enabled: true,
        id: 'recruitment',
        title: t('nav.groups.recruitment'),
        icon: <img className='navIcon' src={suitcase} alt="open positions" />,
        submenu: [
            {
                id: 'openPositions',
                title: t('nav.items.openPositions'),
                path: '/open-positions'
            },
            {
                id: 'talentAnalytics',
                title: t('nav.items.talentAnalytics'),
                path: '/candidate-analytics'
            }
        ]
    },
    {
        enabled: true,
        id: 'talents',
        title: t('nav.groups.talents'),
        path: '/talents',
        icon: <img className='navIcon' src={search} alt="search" />,
        submenu: [
            {
                id: 'talents',
                title: t('nav.items.talents'),
                path: '/talents',
            }
        ]
    },
    {
        enabled: true,
        id: 'simulator',
        title: t('nav.groups.simulator'),
        path: '/team-simulator',
        icon: <JoinInnerOutlinedIcon/>,
        submenu: [
            {
                id: 'simulator',
                title: t('nav.items.simulator'),
                path: '/team-simulator',
            }
        ]
    },
]

export const PrimaryMenu = (userRole) => processedMenu(buildPrimaryMenuItems(), userRole);

export const SecondaryMenu = (userRole) => {
     return [
    {
        enabled: false,
        id: 'billing',
        title: t('nav.items.billing'),
        path: '/billing',
        icon: <img className='navIcon' src={calculator} alt="billing" />,
    },
    {
        enabled: false,
        id: 'assistance',
        title: t('nav.items.assistance'),
        path: '/assistance',
        icon: <ThreePIcon
            sx={{
                color: 'white', // Icon fill color
                '& path': {
                    stroke: 'black', // Border color
                    strokeWidth: 1.25,  // Border thickness
                }
            }}
        />,
    },
    {
        enabled: true,
        id: 'helpCenter',
        title: t('nav.items.helpCenter'),
        path: '/faq-page',
        icon: <img className='navIcon' src={question} alt="FAQ" />,
    },
    {
        enabled: true,
        id: 'accountSettings',
        title: t('nav.items.accountSettings'),
        path: '/settings',
        icon: <img className='navIcon' src={cog} alt="account settings" />,
    },
    {
        enabled: [...Constants.ADMINISTRATIVE_USER_ROLES, Constants.USER_ROLE_HRD].includes(userRole),
        id: 'corporateSettings',
        title: t('nav.items.corporateSettings'),
        path: '/corporate-settings',
        icon: <img className='navIcon' src={companyIcon} alt="corporate settings" />,
    }
]
}

export const MobilePrimaryMenu = (userRole) => processedMenu([
    {
        id: 'talentPool',
        title: t('nav.items.talentPool'),
        path: '/team-review',
        icon: <img className='navIcon' src={groupOfPeople} alt="open positions" />,
    },
    {
        id: 'openPositions',
        title: t('nav.items.openPositions'),
        path: '/open-positions',
        icon: <img className='navIcon' src={suitcase} alt="open positions" />,
    },
    {
        id: 'dashboard',
        title: t('nav.items.dashboard'),
        path: 'dashboard/:companyId',
        icon: <img className='navIcon' style={{height: '100%', width: '55px'}} src={greenLogoNoText} alt="Apex Analytics" />,
    },
    {
        id: 'talents',
        title: t('nav.items.talents'),
        path: '/talents',
        icon: <img className='navIcon' src={search} alt="search" />,
    },
    {
        id: 'simulator',
        title: t('nav.items.simulator'),
        path: '/team-simulator',
        icon: <JoinInnerOutlinedIcon/>
    },
], userRole);

export const MobileSecondaryMenu = (userRole) => [
    
    {
        enabled: false,
        id: 'assistance',
        title: t('nav.items.assistance'),
        path: '/assistance',
        icon: <ThreePIcon
            sx={{
                color: 'white', // Icon fill color
                '& path': {
                    stroke: 'black', // Border color
                    strokeWidth: 1.25,  // Border thickness
                }
            }}
        />,
    },
    {
        enabled: true,
        id: 'helpCenter',
        title: t('nav.items.helpCenter'),
        path: '/faq-page',
        icon: <img className='navIcon' src={question} alt="FAQ" />,
    },
    {
        enabled: true,
        id: 'accountSettings',
        title: t('nav.items.accountSettings'),
        path: '/settings',
        icon: <img className='navIcon' src={cog} alt="account settings" />,
    },
    {
        enabled: [...Constants.ADMINISTRATIVE_USER_ROLES, Constants.USER_ROLE_HRD].includes(userRole),
        id: 'corporateSettings',
        title: t('nav.items.corporateSettings'),
        path: '/corporate-settings',
        icon: <img className='navIcon' src={companyIcon} alt="corporate settings" />,
    }
]
